export default function Style(){
  return (
    <style>
      {`
       .fw-400 {
    font-weight: 400 !important;
  }
  .fs-24-30 {
    font-size: 22px !important;
    line-height: 28px !important;
    font-weight: 400 !important;
  }
  
  .fs-18-27 {
    font-size: 16px !important;
    line-height: 24px !important;
  }
  @media (min-width: 768px) {
    .fs-24-30 {
      font-size: 22px !important;
      line-height: 28px !important;
      font-weight: 400 !important;
    }
  
    .fs-18-27 {
      font-size: 16px !important;
      line-height: 24px !important;
    }
  
    #rcc-confirm-button {
      font-size: 14px !important;
    }
  .CookieConsent {
    border-radius: 7px !important;
    box-shadow: 0 2px 6px 0px rgb(0 0 0 / 30%) !important;
    left: auto !important;
    z-index: 1000 !important;
    right: 0px !important;
    width: 400px !important;
    display: block !important;
    margin: 24px !important;
    padding: 24px !important;
  }
  }
  @media (min-width: 1534px) {
    .fs-24-30 {
      font-size: 24px !important;
      line-height: 30px !important;
      font-weight: 400 !important;
    }
  
    .fs-18-27 {
      font-size: 18px !important;
      line-height: 27px !important;
    }
   #rcc-confirm-button {
      font-size: 16px !important;
   }
   
  }
  
  #rcc-confirm-button{  
      width: 100% !important;
      margin: 0 !important;
      border-radius: none !important;
      padding: 4px 16px !important;
      color: #DBDBDB !important;
      font-weight: 600 !important;
      background-color: #161616 !important;
      letter-spacing: 0.063em;
  
  }
  .CookieConsent > div {
      margin: 0 !important;
  }
  .CookieConsent { 
    box-shadow: 0 2px 6px 0px rgb(0 0 0 / 30%) !important; 
    width: 100% ;
    transition: width 0.5s;
    display: block !important; 
    padding: 24px !important;
  }
        `}
    </style>
  );
}
